import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import GrinHoverPopper from 'components/common/menu/GrinHoverPopper'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'

const useStyles = makeStyles(theme => ({
  root: {
    padding: 10,
    backgroundColor: 'var(--bg-color-32)',
    boxShadow: '0px 4px 4px 0px #00000073'
  },
  text: {
    color: 'var(--text-color-26)'
  }
}))

const NewerAppVersionRequired = ({ itemRef }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <GrinHoverPopper
      anchorEl={itemRef.current}
      followMouse={false}
      offset={{ y: 3, x: -295 }}
      grinPopperProps={{
        className: classes.root
      }}
    >
      <DazzedParagraph12 strong>{t('pages.patients.patientSidebar.newerAppVersionRequiredMessage')}</DazzedParagraph12>
    </GrinHoverPopper>
  )
}

export default NewerAppVersionRequired
